import MediaForm from '@Components/MediaForm';
import { MediaContextProvider } from '../../context/mediaContext/mediaContext';

export default function Details() {
	return (
		<MediaContextProvider>
			<MediaForm viewOnly />
		</MediaContextProvider>
	);
}